import Routing from "./Component/Routing/Routing";

function App() {
  return (
    <div>
      <Routing />
    </div>
  );
}
export default App;
